import React, { useMemo } from 'react';
import { Box } from '@withjoy/joykit';
import { styles } from './ProductStorefrontStatusBadge.styles';
import { ProductCatalogStorefrontStatus } from '@graphql/generated';
import { useTranslation } from '@shared/core';

interface ProductStorefrontStatusBadgeProps extends Readonly<{}> {
  storefrontStatus: Maybe<ProductCatalogStorefrontStatus>;
  variant?: Maybe<'inline' | 'badge' | 'head'>;
  type?: Maybe<'note' | 'title'>;
}

export const ProductStorefrontStatusBadge = ({ storefrontStatus, variant = 'inline', type = 'note' }: ProductStorefrontStatusBadgeProps) => {
  const isNote = type === 'note';
  const { t } = useTranslation('catalogRegistry');
  const productDetailPageTranslations = t('productDetailPage');

  const helperText = useMemo<Maybe<string>>(() => {
    switch (storefrontStatus) {
      case ProductCatalogStorefrontStatus.discontinued:
        return isNote ? productDetailPageTranslations.discontinuedItemNote() : productDetailPageTranslations.discontinuedItemTitle();

      case ProductCatalogStorefrontStatus.comingSoon:
        return isNote ? productDetailPageTranslations.comingSoonItemNote() : productDetailPageTranslations.comingSoonItemTitle();

      case ProductCatalogStorefrontStatus.backordered:
        return isNote ? productDetailPageTranslations.backorderedItemNote() : productDetailPageTranslations.backorderedItemTitle();

      default:
        return;
    }
  }, [productDetailPageTranslations, storefrontStatus, isNote]);

  const helperAttr = useMemo<{}>(() => {
    switch (variant) {
      case 'badge':
        return {
          typographyVariant: 'body1',
          fontWeight: 'semibold',
          __css: styles.helperTextBadge
        };

      case 'head':
        return {
          __css: styles.helperTextHead
        };

      default:
        return {
          typographyVariant: 'body1',
          __css: styles.helperTextInline
        };
    }
  }, [variant]);

  return <Box {...helperAttr}>{helperText}</Box>;
};
